import { get } from '@ally/metronome-ui';
import styled, { css } from 'styled-components';
const itemStyles = css `
  padding: 12px 0px;
  line-height: 22px;
`;
const listItemStyles = css `
  list-style: none;
  ${itemStyles};
`;
export const StyledMenuItem = styled.div `
  ${itemStyles};
  border-bottom: 1px solid ${get.colors('slate-2')};
`;
export const AccordionMenuItem = styled.li `
  ${listItemStyles};
`;
export const StyledSubMenuItem = styled.li `
  ${listItemStyles};
  border-bottom: 1px solid ${get.colors('slate-2')};
`;
export const StyledSubMenuList = styled.ul `
  width: 100%;
  margin: ${get.space('none')};
  padding: ${get.space('none')};
  li:last-child {
    padding-bottom: 0px;
  }
`;
//# sourceMappingURL=StyledMenuComponents.js.map